import React, { useEffect, useRef, useState } from 'react'
import { Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody } from 'reactstrap'
import Vector from './Vector';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import Preloader from '../../../Components/Common/Preloader';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import country from '../../../common/country';
import { replace } from 'redux-first-history';
import { setLocationData, toggleLocationModal } from '../../../slices/analytics/reducer';
import DetailCard from '../DetailCard';
import { getLocationTable } from '../../../slices/analytics/thunk';

function Location() {
  const dispatch = useDispatch();
  const selectStates = createSelector(state => state, state => ({
    locationLoader: state.Analytics.locationLoader,
    locationData: state.Analytics.locationData,
    analyticsCampaigns: state.Analytics.analyticsCampaigns,
  }));
  const { locationLoader, locationData, analyticsCampaigns } = useSelector(selectStates);
  const [tableData, setTableData] = useState(null);
  
  function openLocation() {
    dispatch(getLocationTable(analyticsCampaigns));
  }

  useEffect(() => {
    if (locationData) {
      const keys = Object.keys(locationData);
      const locationArr = keys.map(item => {
        return {
          country: item,
          impression: locationData[item]
        }
      });
      setTableData(locationArr);
    } else {
      setTableData(null);
    }
  }, [locationData])

  const tableRef = useRef();
  useEffect(() => {
    if (Array.isArray(tableData) && tableData.length > 0) {
      try {
        const table = $(tableRef.current).DataTable({
          data: tableData,
          columns: [
            {
              data: 'country',
              title: 'Countries',
              render: (data, type, row) => {
                const foundCountry = country.find(item => item.short.toUpperCase() === data);
                if (foundCountry) {
                  return foundCountry.name;
                } else {
                  return data;
                }
              }
            },
            {
              data: 'impression',
              title: 'Impressions',
            }
          ],
          responsive: true,
          destroy: true,
          searching: false,
          paging: true,
          info: false,
          sortable: false,
          entries: false,
        });
        tableRef.current.parentElement.parentElement.parentElement.querySelector('.row').style.display = 'none';

        return function () {
          table.destroy();
        }
      } catch (error) {
        // console.log(error);
      }
    }
  }, [tableData]);

  return (
    <React.Fragment>
      {locationLoader ?
        <Card>
          <Preloader isComponentLoader={true} width={150} height={150} />
        </Card>
        : Array.isArray(tableData) ?
          <Card>
            <CardHeader>
              Locations
            </CardHeader>
            <CardBody>
              <div className='text-center' style={{ height: '250px' }}>
                <Vector value='world-mill' color='#f3f6f9' data={locationData} />
              </div>
              <div className='table-responsive table-card mt-0 pt-2'>
                <table
                  className="align-middle table-nowrap mb-0 table"
                  style={{ width: "100%" }}
                  ref={tableRef}
                >
                  <thead className="table-light"></thead>
                  <tbody></tbody>
                </table>
              </div>
            </CardBody>
          </Card> :
          <DetailCard color='warning'
            textColor='primary'
            avatar="ri-user-location-line"
            header="Location-Based Impressions Overview"
            text="Track the number of impressions based on location to optimize your audience reach and ensure maximum visibility in targeted areas."
            onClick={openLocation} />
      }

    </React.Fragment>
  )
}

export default Location